/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface BeamAnalysisCorrectionSettingsDto
 */
export interface BeamAnalysisCorrectionSettingsDto {
    /**
     * 
     * @type {boolean}
     * @memberof BeamAnalysisCorrectionSettingsDto
     */
    adjustAirTemperature?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BeamAnalysisCorrectionSettingsDto
     */
    adjustAirPressure?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BeamAnalysisCorrectionSettingsDto
     */
    adjustReferenceTemperature?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BeamAnalysisCorrectionSettingsDto
     */
    adjustCorrectionFactor?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BeamAnalysisCorrectionSettingsDto
     */
    $type?: BeamAnalysisCorrectionSettingsDtoTypeEnum;
}


/**
 * @export
 */
export const BeamAnalysisCorrectionSettingsDtoTypeEnum = {
    PtwPtw100BeamAnalysisApplicationJobExecutionDtoBeamAnalysisCorrectionSettingsDtoPtwPtw100BeamAnalysisApplication: 'Ptw.Ptw100.BeamAnalysis.Application.JobExecution.Dto.BeamAnalysisCorrectionSettingsDto, Ptw.Ptw100.BeamAnalysis.Application'
} as const;
export type BeamAnalysisCorrectionSettingsDtoTypeEnum = typeof BeamAnalysisCorrectionSettingsDtoTypeEnum[keyof typeof BeamAnalysisCorrectionSettingsDtoTypeEnum];



/**
 * Check if a given object implements the BeamAnalysisCorrectionSettingsDto interface.
 */
export function instanceOfBeamAnalysisCorrectionSettingsDto(value?: unknown): value is BeamAnalysisCorrectionSettingsDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(BeamAnalysisCorrectionSettingsDtoTypeEnum)[0];
}

export function BeamAnalysisCorrectionSettingsDtoFromJSON(json: any): BeamAnalysisCorrectionSettingsDto {
    return BeamAnalysisCorrectionSettingsDtoFromJSONTyped(json, false);
}

export function BeamAnalysisCorrectionSettingsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeamAnalysisCorrectionSettingsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'adjustAirTemperature': json['adjustAirTemperature'] == null ? undefined : json['adjustAirTemperature'],
        'adjustAirPressure': json['adjustAirPressure'] == null ? undefined : json['adjustAirPressure'],
        'adjustReferenceTemperature': json['adjustReferenceTemperature'] == null ? undefined : json['adjustReferenceTemperature'],
        'adjustCorrectionFactor': json['adjustCorrectionFactor'] == null ? undefined : json['adjustCorrectionFactor'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function BeamAnalysisCorrectionSettingsDtoToJSON(value?: BeamAnalysisCorrectionSettingsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'adjustAirTemperature': value['adjustAirTemperature'],
        'adjustAirPressure': value['adjustAirPressure'],
        'adjustReferenceTemperature': value['adjustReferenceTemperature'],
        'adjustCorrectionFactor': value['adjustCorrectionFactor'],
        '$type': value['$type'],
    });
}

